import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class LoggerApiService {

  constructor(  
    private httpClient: HttpClient) { }
    // sendHttpLog(logData: any) {
    //   logData = {
    //     ...logData,
    //     ...environment.loggerApiData.general,
    //     loginResponse: JSON.stringify(this.authService.loginResponse)
  
    //   };
    //   this.httpClient.post(environment.loggerApiUrl, logData).subscribe((res) => {
    //     // console.log(res);
    //   }, (err) => {
    //     console.error(err);
    //   });
    // }
  
    sendEventLog(logData: any): void {
      logData = {
        ...logData,
        ...environment.loggerApiData.general,
        ...environment.loggerApiData.events
      }
      // let header = new HttpHeaders({
      //   timeout: '600000',
      // });

      const httpOptions = {
        header: new HttpHeaders({
          timeout: '600000',
          'Accept': 'application/json',
          'responseType':'blob',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
        })
      };
      setTimeout(() => {
        try {
          this.httpClient.post(environment.loggerApiUrl, logData, { headers: httpOptions.header }).subscribe((res) => {
            // console.log(res);
          }, (err) => {
            console.log('error logging to elk: ', err);
          });
        } catch (error) {
          console.error('Error in sendEventLog:', error);
        }

      }, 100);
  }

  // similar to sendEventLog, but use sendBeacon, and call it sendBeaconLog
  sendBeaconLog(logData: any): void {
    logData = {
      ...logData,
      ...environment.loggerApiData.general,
      ...environment.loggerApiData.events
    };
    try {
      const blob = new Blob([JSON.stringify(logData)], { type: 'application/json' });
      navigator.sendBeacon(environment.loggerApiUrl, blob);
    } catch (error) {
      console.error('Error in sendBeaconLog:', error);
    }
  }

}
